import ApplicationModel, { attr } from '../ApplicationModel';
import { type ResponsibilityAttributes } from './generated/ResponsibilityAttributes';
import { model } from '../modelBuilder';

interface Responsibility extends ResponsibilityAttributes {}

@model
class Responsibility extends ApplicationModel {
  // Start auto-generated
  static typename: 'Responsibility' = 'Responsibility';
  get typename(): 'Responsibility' {
    return 'Responsibility';
  }

  static internalTypename: 'Responsibility' = 'Responsibility';
  get internalTypename(): 'Responsibility' {
    return 'Responsibility';
  }

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
  };
  // End auto-generated
}

export default Responsibility;
